import React from 'react'

const Spinner = () => {
    return (<div className="loading">
            <span className="spinner-border" role="status"></span>
            <p className="d-block mt-3">Cargando</p>
        </div>)
}

export default Spinner